module.exports = __webpack_public_path__ + "img/login3.2c1f5e95.jpg";